export default {
  home: '首页',
  about: '关于我们',
  contact: '联系我们',
  login: '登录',
  logout: '退出登录',
  switchLang: '切换语言',
  welcome: '欢迎访问我们的官网',
}
